<template>
    <div class="flex items-center justify-between">
        <p class="text-2xl font-medium ct-text-1">
            <template v-if="beforeTitle">
                <span class="ct-text-4" v-html="beforeTitle"> </span> /
            </template>
            {{ title }}
        </p>
        <router-link :to="{ name: PLAYER_ROUTE_NAMES.project }">
            <ButtonPrimaryMd>
                <PencilSquareIcon />
                <span> {{ $t("player.panel.edit") }}</span>
            </ButtonPrimaryMd>
        </router-link>
    </div>
</template>

<script>
import { ButtonPrimaryMd } from "@easy/ui/buttons";
import { PencilSquareIcon } from "@easy/ui/icons";
import { PLAYER_ROUTE_NAMES } from "@/apps/player/player.routes";

export default {
    name: "PlayerPanelHeader",
    components: {
        ButtonPrimaryMd,
        PencilSquareIcon,
    },
    props: {
        beforeTitle: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            PLAYER_ROUTE_NAMES,
        };
    },
};
</script>
